import React from "react";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";

/**
 * Custom day cell for Manage Appointment / dashboard calendars.
 * Shows closed-day styling and pending/confirmed appointment dot badges.
 */
export default function ManageAppointmentPickersDay(props) {
  const {
    day,
    outsideCurrentMonth,
    closedDays = [],
    disabled,
    getAppointmentCountsForDate,
    chairScheduledDates,
    highlightedDays: _highlightedDays,
    sx: slotSx,
    ...pickersDayRest
  } = props;

  const year = day.toDate().getFullYear();
  const month = String(day.toDate().getMonth() + 1).padStart(2, "0");
  const dayNum = String(day.toDate().getDate()).padStart(2, "0");
  const dateStr = `${year}-${month}-${dayNum}`;
  const isClosed = closedDays.includes(dateStr);
  const hasChairSchedule =
    chairScheduledDates instanceof Set
      ? chairScheduledDates.has(dateStr)
      : Array.isArray(chairScheduledDates)
        ? chairScheduledDates.includes(dateStr)
        : false;

  const appointmentCounts = getAppointmentCountsForDate
    ? getAppointmentCountsForDate(day.toDate())
    : { pending: 0, confirmed: 0, completed: 0 };
  const hasAppointments =
    appointmentCounts.pending > 0 ||
    appointmentCounts.confirmed > 0 ||
    appointmentCounts.completed > 0;

  const mergedSx =
    slotSx && typeof slotSx === "object" && !Array.isArray(slotSx) ? slotSx : {};

  return (
    <div style={{ position: "relative", display: "inline-flex" }}>
      <PickersDay
        {...pickersDayRest}
        outsideCurrentMonth={outsideCurrentMonth}
        day={day}
        disabled={disabled}
        sx={{
          ...mergedSx,
          ...(isClosed && {
            backgroundColor: "#ff6b6b !important",
            color: "white !important",
            fontWeight: "bold !important",
            borderRadius: "8px !important",
            border: "2px solid #ff6b6b !important",
            "&:hover": {
              backgroundColor: "#ff5252 !important",
            },
            "&.Mui-selected": {
              backgroundColor: "#ff6b6b !important",
              color: "white !important",
            },
          }),
          ...(hasChairSchedule &&
            !isClosed && {
              backgroundColor: "rgba(197, 165, 114, 0.25) !important",
              color: "#2C251E !important",
              fontWeight: "600 !important",
              borderRadius: "8px !important",
              border: "2px solid #C5A572 !important",
              "&.Mui-selected": {
                backgroundColor: "#59544A !important",
                color: "white !important",
                border: "2px solid #59544A !important",
              },
            }),
        }}
      />

      {hasAppointments && (
        <div
          style={{
            position: "absolute",
            top: "4px",
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            gap: "2px",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10,
            pointerEvents: "none",
          }}
        >
          {appointmentCounts.confirmed > 0 && (
            <div
              style={{
                width: "5px",
                height: "5px",
                borderRadius: "50%",
                backgroundColor: "#80cd97ff",
                border: "1px solid #59544A",
              }}
            />
          )}

          {appointmentCounts.pending > 0 && (
            <div
              style={{
                width: "6px",
                height: "6px",
                borderRadius: "50%",
                backgroundColor: "#ffd48eff",
                border: "1px solid #59544A",
              }}
            />
          )}
        </div>
      )}
    </div>
  );
}
